
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_46510","data-name":"Group 46510","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15712","data-name":"Rectangle 15712","width":"25","height":"25","fill":"none"}})])]),_c('rect',{attrs:{"id":"Rectangle_15711","data-name":"Rectangle 15711","width":"25","height":"25","fill":"none"}}),_c('g',{attrs:{"id":"Group_46497","data-name":"Group 46497"}},[_c('g',{attrs:{"id":"Group_46496","data-name":"Group 46496","clip-path":"url(#clip-path)","fill":"none","stroke":"#8d97a1","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_38733","data-name":"Path 38733","d":"M6.9 7.737l1.383 10.527a2.518 2.518 0 00.566 1.459 1.909 1.909 0 001.386.6h4.528a1.909 1.909 0 001.386-.6 2.723 2.723 0 00.566-1.469L18.1 7.727"}}),_c('path',{attrs:{"id":"Path_38734","data-name":"Path 38734","d":"M14.963 6.837v-1.25a.956.956 0 00-.242-.649.835.835 0 00-.619-.261h-3.208a.838.838 0 00-.611.261.923.923 0 00-.248.641v1.258"}}),_c('line',{attrs:{"id":"Line_1506","data-name":"Line 1506","x2":"13.852","transform":"translate(5.574 7.726)"}})])])])
          )
        }
      }
    